(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _accordion = _interopRequireDefault(require("./module/accordion.js"));
var _addAriaLabel = _interopRequireDefault(require("./module/addAriaLabel.js"));
var _combinationSelectText = _interopRequireDefault(require("./module/combinationSelectText.js"));
var _inputValueChange = _interopRequireDefault(require("./module/inputValueChange.js"));
var _noOpener = _interopRequireDefault(require("./module/noOpener.js"));
var _numericValidator = _interopRequireDefault(require("./module/numericValidator.js"));
var _preloadImage = _interopRequireDefault(require("./module/preloadImage.js"));
var _selectBoxClassToggle = _interopRequireDefault(require("./module/selectBoxClassToggle.js"));
var _smoothScroll = _interopRequireDefault(require("./module/smoothScroll.js"));
var _submitStateChange = _interopRequireDefault(require("./module/submitStateChange.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/* module ==============================*/

/* selectbox ==============================*/
var selectBoxStyle = new _selectBoxClassToggle["default"].init();
var selectboxCombination = new _combinationSelectText["default"].init();
var submitActivation = function (ua) {
  if (ua.indexOf('msie') < 0 && ua.indexOf('trident') < 0) new _submitStateChange["default"].init('.submitStateChange');
}(window.navigator.userAgent.toLowerCase());

/* numeric validator ==============================*/
var numericValidation = new _numericValidator["default"]('.textLine[type="number"]').init();

/* financialInstitution ==============================*/
var financialInstitution = new _inputValueChange["default"].init('.list-anchor.-financialInstitution a');

/* noopener ==============================*/
var noopener = new _noOpener["default"].init();

/* smooth scroll ==============================*/
var smoothscroll = new _smoothScroll["default"]('._isModal, ._isAccordion, ._isNotSmooth, .suggest a').init();

/* link : inpage links ==============================*/
var linkInPage = new _addAriaLabel["default"]('a.-anchor', '（ページ内リンク）').init();

/* link : external links ==============================*/
var linkExternalPage = new _addAriaLabel["default"]('a.link-external, .-external > a, _isExternal', '（新規ウィンドウで開く）').init();

/* accordion ==============================*/
var accordionInit = new _accordion["default"]('.hiddenAreaTrigger').init();

/* table ==============================*/
var scrollTable = function () {
  var target = document.querySelectorAll('.container-table.-scrollable');
  try {
    if (target.length < 1) throw 'There is no scrollable table.';
    new ScrollHint('.container-table.-scrollable', {
      i18n: {
        scrollable: 'スクロールできます'
      }
    });
  } catch (error) {
    console.log(error);
  }
}();

/* modal ==============================*/
var modalTrigger = function () {
  var trigger = document.querySelectorAll('a._isModal, button._isModal');
  try {
    if (trigger.length < 1) throw 'There is no modal element.';
    trigger.forEach(function (element) {
      element.addEventListener('click', function (event) {
        event.preventDefault();
      }, false);
    });
    MicroModal.init({
      disableScroll: true,
      awaitOpenAnimation: true,
      awaitCloseAnimation: true,
      disableFocus: true
    });
  } catch (error) {
    console.log(error);
  }
}();
var modalDefaultOpen = function () {
  var modalContainer = document.querySelectorAll('.container-modal');
  try {
    if (modalContainer.length < 1) throw 'There is no modal element.';
    for (var i = 0; i < modalContainer.length; i++) {
      if (modalContainer[i].classList.contains('_isDefaultOpen')) {
        MicroModal.show(modalContainer[i].getAttribute('id'), {
          disableScroll: true,
          awaitOpenAnimation: true,
          awaitCloseAnimation: true,
          disableFocus: true
        });
        break;
      }
    }
  } catch (error) {
    console.log(error);
  }
}();

/* Icons Preload ==============================*/
var icons = ['/common/image/icon/icon-accordion-down-blue.svg', '/common/image/icon/icon-accordion-down-white.svg', '/common/image/icon/icon-accordion-down.svg', '/common/image/icon/icon-accordion-up-blue.svg', '/common/image/icon/icon-accordion-up-white.svg', '/common/image/icon/icon-accordion-up.svg', '/common/image/icon/icon-button-disabled-next-middle.svg', '/common/image/icon/icon-button-disabled-next.svg', '/common/image/icon/icon-button-disabled-previous-middle.svg', '/common/image/icon/icon-button-disabled-previous.svg', '/common/image/icon/icon-button-next-hover-middle.svg', '/common/image/icon/icon-button-next-hover.svg', '/common/image/icon/icon-button-next-middle.svg', '/common/image/icon/icon-button-next.svg', '/common/image/icon/icon-button-previous-hover-middle.svg', '/common/image/icon/icon-button-previous-hover.svg', '/common/image/icon/icon-button-previous-middle.svg', '/common/image/icon/icon-button-previous.svg', '/common/image/icon/icon-button-secondary-next-middle.svg', '/common/image/icon/icon-button-secondary-next.svg', '/common/image/icon/icon-button-secondary-previous-middle.svg', '/common/image/icon/icon-button-secondary-previous.svg', '/common/image/icon/icon-check-checked.svg', '/common/image/icon/icon-check-disabled-checked.svg', '/common/image/icon/icon-check-disabled.svg', '/common/image/icon/icon-check-focus-checked.svg', '/common/image/icon/icon-check-focus.svg', '/common/image/icon/icon-check-invalid.svg', '/common/image/icon/icon-check.svg', '/common/image/icon/icon-completion.svg', '/common/image/icon/icon-link-anchor.svg', '/common/image/icon/icon-link-error-anchor.svg', '/common/image/icon/icon-link-error.svg', '/common/image/icon/icon-link.svg', '/common/image/icon/icon-pdf.svg', '/common/image/icon/icon-radio-checked.svg', '/common/image/icon/icon-radio-disabled-checked.svg', '/common/image/icon/icon-radio-disabled.svg', '/common/image/icon/icon-radio-focus-checked.svg', '/common/image/icon/icon-radio-focus.svg', '/common/image/icon/icon-radio-invalid.svg', '/common/image/icon/icon-radio.svg', '/common/image/icon/icon-status-error.svg', '/common/image/icon/icon-status-exclamation.svg', '/common/image/icon/icon-status-information.svg', '/common/image/icon/icon-status-warning.svg', '/common/image/icon/icon-stepper-lv2-current.svg', '/common/image/icon/icon-stepper-lv2.svg', '/common/image/icon/icon-telephone.svg', '/common/image/icon/icon-window-white.svg', '/common/image/icon/icon-window.svg'];
var preloadIcons = new _preloadImage["default"](icons).init();

/* IE ==============================*/
var ieJudge = function (ua) {
  if (ua.indexOf('msie') >= 0 || ua.indexOf('trident') >= 0) window.document.body.classList.add('_isIE');
}(window.navigator.userAgent.toLowerCase());

},{"./module/accordion.js":2,"./module/addAriaLabel.js":3,"./module/combinationSelectText.js":4,"./module/inputValueChange.js":6,"./module/noOpener.js":7,"./module/numericValidator.js":8,"./module/preloadImage.js":9,"./module/selectBoxClassToggle.js":10,"./module/smoothScroll.js":11,"./module/submitStateChange.js":12}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _easing = _interopRequireDefault(require("./easing.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * アコーディオンコンポーネント
 * @module accordion
 * @constructor
 * @param {HTMLElement} element - トリガー
 */
var accordion = /*#__PURE__*/function () {
  function accordion(element) {
    _classCallCheck(this, accordion);
    this.query = element;
    this.element = document.querySelectorAll(element);
  }
  _createClass(accordion, [{
    key: "ariaLabel",
    value: function ariaLabel(element, activity) {
      // aria-label設定
      var ariaLabel;
      if (activity) {
        ariaLabel = "\u300C".concat(element.textContent, "\u300D\u3092\u9589\u3058\u308B");
      } else {
        ariaLabel = "\u300C".concat(element.textContent, "\u300D\u3092\u958B\u304F");
      }
      return ariaLabel;
    }
  }, {
    key: "animation",
    value: function animation(trigger, panel, activity) {
      var _this = this;
      // 開閉アニメーション処理
      var radios = panel.querySelectorAll('input[type=radio]');
      var checkedRadio = [];
      var animation = {
        'start': function start() {
          return new Promise(function (resolve, reject) {
            if (activity) {
              panel.classList.remove('_isInactive');
              trigger.classList.remove('_isInactive');
              panel.classList.add('_isActive');
              trigger.classList.add('_isActive');
            } else {
              trigger.classList.remove('_isActive');
              trigger.classList.add('_isInactive');
            }
            radios.forEach(function (radio) {
              if (radio.checked) {
                checkedRadio.push(radio);
              }
            });
            resolve();
          });
        },
        'process': function process() {
          return new Promise(function (resolve, reject) {
            var duration = 300;
            var interval = 16;
            var parameter = _this.getPanelHeight(panel);
            var height = parameter.height;
            var paddingTop = parameter.paddingTop;
            var paddingBottom = parameter.paddingBottom;
            var linear = function linear(h) {
              return counter / duration * h;
            };
            var panelHeight = activity ? 0 : height;
            var panelPaddingTop = activity ? 0 : paddingTop;
            var panelPaddingBottom = activity ? 0 : paddingBottom;
            var counter = 0;
            var timer = setInterval(function () {
              panel.style.height = "".concat(panelHeight, "px");
              panel.style.paddingTop = "".concat(panelPaddingTop, "px");
              panel.style.paddingBottom = "".concat(panelPaddingBottom, "px");
              if (counter >= duration) {
                clearInterval(timer);
                if (checkedRadio.length > 0) {
                  checkedRadio.forEach(function (radio) {
                    radio.checked = true;
                  });
                }
                resolve();
              }
              if (activity) {
                if (counter === 0) {
                  panel.style.display = 'block';
                }
                if (panelHeight < height) {
                  panelHeight = _easing["default"].quad(counter / duration, 'out') * height;
                  panelPaddingTop = _easing["default"].quad(counter / duration, 'out') * paddingTop;
                  panelPaddingBottom = _easing["default"].quad(counter / duration, 'out') * paddingBottom;
                } else {
                  panelHeight = height;
                  panelPaddingTop = paddingTop;
                  panelPaddingBottom = paddingBottom;
                }
              } else {
                if (height >= panelHeight) {
                  panelHeight = height - _easing["default"].quad(counter / duration, 'out') * height;
                  panelPaddingTop = paddingTop - _easing["default"].quad(counter / duration, 'out') * paddingTop;
                  panelPaddingBottom = paddingBottom - _easing["default"].quad(counter / duration, 'out') * paddingBottom;
                } else {
                  panelHeight = 0;
                  panelPaddingTop = 0;
                  panelPaddingBottom = 0;
                }
              }
              counter += interval;
            }, interval);
          });
        },
        'end': function end() {
          return new Promise(function (resolve, reject) {
            panel.style.height = '';
            panel.style.paddingTop = '';
            panel.style.paddingBottom = '';
            if (activity == false) {
              panel.classList.remove('_isActive');
              panel.classList.add('_isInactive');
              panel.style.display = 'none';
            }
            resolve();
          });
        }
      };
      var executionPromise = Promise.resolve();
      executionPromise.then(animation.start).then(animation.process).then(animation.end)["catch"](function (e) {
        console.error(e);
      });
    }
  }, {
    key: "inActivate",
    value: function inActivate(t, p, label) {
      // 全パネル非表示
      t.setAttribute('aria-expanded', false);
      t.setAttribute('aria-haspopup', true);
      if (label) t.setAttribute('aria-label', this.ariaLabel(t, false));
      p.setAttribute('aria-hidden', true);
      if (p.classList.contains('_isActive')) {
        this.animation(t, p, false);
      }
    }
  }, {
    key: "activate",
    value: function activate(t, p, label) {
      t.setAttribute('aria-expanded', true);
      t.setAttribute('aria-haspopup', false);
      if (label) t.setAttribute('aria-label', this.ariaLabel(t, true));
      p.setAttribute('aria-hidden', false);
      this.animation(t, p, true);
    }
  }, {
    key: "getPanelHeight",
    value: function getPanelHeight(element) {
      // パネルの高さ取得
      var clone = element.cloneNode(true); // パネルのクローン生成
      element.parentNode.appendChild(clone); // パネルと同様の箇所にクローン挿入
      // 高さ取得のためdisplay:block
      clone.style.cssText = 'display: block; height: auto; visibility: hidden;';
      clone.classList.remove('_isInactive');
      // サイズ取得
      var height = parseFloat(document.defaultView.getComputedStyle(clone, null).height);
      var paddingTop = parseFloat(document.defaultView.getComputedStyle(clone, null).paddingTop);
      var paddingBottom = parseFloat(document.defaultView.getComputedStyle(clone, null).paddingBottom);
      var panelSize = {
        'height': height - (paddingTop + paddingBottom),
        'paddingTop': paddingTop,
        'paddingBottom': paddingBottom
      };
      element.parentNode.removeChild(clone); // クローン削除
      return panelSize;
    }
  }, {
    key: "handleClick",
    value: function handleClick(trigger, panel) {
      var _this2 = this;
      // クリックイベント
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        var isActive = trigger.classList.contains('_isActive') ? 1 : 0;
        var toggle = {
          'close': function close() {
            return new Promise(function (resolve, reject) {
              _this2.inActivate(trigger, panel, true);
              resolve();
            });
          },
          'open': function open() {
            if (isActive == false) {
              _this2.activate(trigger, panel, true);
            }
          }
        };
        var executionPromise = Promise.resolve();
        executionPromise.then(toggle.close).then(toggle.open)["catch"](function (e) {
          console.error(e);
        });
      });
    }
  }, {
    key: "handleCheck",
    value: function handleCheck(trigger, panel) {
      var _this3 = this;
      // チェックボックスイベント
      trigger.addEventListener('change', function (event) {
        var isActive = trigger.classList.contains('_isActive') ? 1 : 0;
        var toggle = {
          'close': function close() {
            return new Promise(function (resolve, reject) {
              _this3.inActivate(trigger, panel, false);
              resolve();
            });
          },
          'open': function open() {
            if (isActive == false) {
              _this3.activate(trigger, panel, false);
              if (trigger.getAttribute('data-accordionScroll')) {
                setTimeout(function () {
                  window.scrollTo({
                    top: Math.round(trigger.getBoundingClientRect().top + window.pageYOffset),
                    behavior: 'smooth'
                  });
                }, 400);
              }
            }
          }
        };
        var executionPromise = Promise.resolve();
        executionPromise.then(toggle.close).then(toggle.open)["catch"](function (e) {
          console.error(e);
        });
      });
    }
  }, {
    key: "handleRadio",
    value: function handleRadio(radioCount) {
      var _this4 = this;
      // チェックボックスイベント
      if (radioCount === 0) {
        var radios = document.querySelectorAll('input[type=radio]');
        radios.forEach(function (trigger) {
          trigger.addEventListener('change', function (event) {
            radios.forEach(function (element) {
              var areaId = element.getAttribute('data-hiddenArea') !== null ? element.getAttribute('data-hiddenArea') : false;
              var isTrigger = areaId ? true : false;
              if (isTrigger) {
                var _trigger = element;
                var isChecked = _trigger.checked;
                var panel = document.getElementById(areaId);
                if (isChecked == true && panel.style.display === 'none') {
                  _this4.activate(_trigger, panel, false);
                  if (_trigger.getAttribute('data-accordionScroll')) {
                    setTimeout(function () {
                      window.scrollTo({
                        top: Math.round(_trigger.getBoundingClientRect().top + window.pageYOffset),
                        behavior: 'smooth'
                      });
                    }, 400);
                  }
                } else if (isChecked == false && panel.style.display === 'block') {
                  _this4.inActivate(_trigger, panel, false);
                }
              }
            });
          });
        });
      }
    }
  }, {
    key: "init",
    value: function init() {
      var _this5 = this;
      // 初期化
      try {
        // 指定されたセレクタが存在しない場合
        if (this.element.length == false) throw 'There is no element to apply the "accordion"';
        var radioCount = 0;

        // トリガー・パネル初期化
        this.element.forEach(function (trigger, i) {
          trigger.classList.add('_isInactive');
          trigger.setAttribute('aria-haspopup', true);
          trigger.setAttribute('aria-expanded', false);
          var triggerTag = trigger.tagName.toLowerCase();
          var triggerType = triggerTag === 'input' ? trigger.getAttribute('type') : undefined;
          var panelId = trigger.getAttribute('data-hiddenArea');
          var panel = document.getElementById(panelId);
          if (panel) {
            // 初期時展開設定による分岐
            if (panel.classList.contains('_isActive')) {
              panel.setAttribute('aria-hidden', false);
            } else if (triggerType && trigger.checked) {
              panel.setAttribute('aria-hidden', false);
              panel.classList.add('_isActive');
              panel.style.display = 'block';
            } else {
              panel.style.display = 'none';
              panel.setAttribute('aria-hidden', true);
              panel.classList.add('_isInactive');
            }
          }

          // トリガーの初期化
          if (trigger) {
            // 初期時展開設定による分岐
            trigger.setAttribute('aria-controls', panelId);
            if (triggerTag === 'button' || triggerTag === 'a') trigger.setAttribute('aria-label', _this5.ariaLabel(trigger, false));
            if (panel.classList.contains('_isActive') || triggerType && trigger.checked) {
              trigger.classList.remove('_isInactive');
              trigger.classList.add('_isActive');
              trigger.setAttribute('aria-haspopup', false);
              trigger.setAttribute('aria-expanded', true);
              if (triggerTag === 'button' || triggerTag === 'a') trigger.setAttribute('aria-label', _this5.ariaLabel(trigger, true));
            }
            if (triggerTag === 'button' || triggerTag === 'a') {
              _this5.handleClick(trigger, panel);
            } else if (triggerType === 'checkbox') {
              _this5.handleCheck(trigger, panel);
            } else if (triggerType === 'radio') {
              _this5.handleRadio(radioCount);
              radioCount++;
            }
          }
        });
      } catch (error) {
        console.log(error);
      }
    }
  }]);
  return accordion;
}();
exports["default"] = accordion;

},{"./easing.js":5}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * aria-label追加
 * @module addAriaLabel
 * @constructor
 * @param {HTMLElement} selector - 適用対象
 * @param {string} label - 追加ラベルテキスト
 * @param {string} exclusion - 除外対象のセレクタ（文字列。複数の場合はカンマ区切り）
 */
var addAriaLabel = /*#__PURE__*/function () {
  function addAriaLabel(selector, label, exclusion) {
    _classCallCheck(this, addAriaLabel);
    this.selector = selector;
    this.label = label;
    this.exclusion = exclusion ? exclusion : undefined;
  }
  _createClass(addAriaLabel, [{
    key: "init",
    value: function init() {
      var _this = this;
      try {
        var exclusion_string = '';
        if (this.exclusion) {
          if (this.exclusion.match(',')) {
            var exclusionList = this.exclusion.replace(', ', ',').split(',');
            exclusionList.forEach(function (element) {
              exclusion_string += ":not(".concat(element, ")");
            });
          } else {
            exclusion_string = ":not(".concat(this.exclusion, ")");
          }
        }
        var anchor = document.querySelectorAll("".concat(this.selector).concat(exclusion_string));
        if (anchor.length < 1) throw "There is no element (".concat(this.selector, ") to apply the \"addAriaLabel\"");
        anchor.forEach(function (element) {
          if (element.textContent.replace(/\s/g, '').length > 0) {
            element.setAttribute('aria-label', "".concat(element.textContent).concat(_this.label));
          } else if (element.innerHTML.match(/alt/g)) {
            element.setAttribute('aria-label', "".concat(element.querySelector('img').getAttribute('alt')).concat(_this.label));
          }
        });
      } catch (error) {
        console.log(error);
      }
    }
  }]);
  return addAriaLabel;
}();
exports["default"] = addAriaLabel;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * 選択肢によるテキストフィールドの活性化
 * @module combinationSlectText
 */
var combinationSlectText = /*#__PURE__*/function () {
  function combinationSlectText() {
    _classCallCheck(this, combinationSlectText);
  }
  _createClass(combinationSlectText, null, [{
    key: "init",
    value: function init() {
      try {
        var container = document.querySelectorAll('.combination-selectText');
        if (container.length < 1) throw 'There is no element to apply the "combinarionSlectText"';
        container.forEach(function (element) {
          var selector = element.querySelectorAll('.combinationSelector');
          var trigger = element.querySelector('.combinationTrigger');
          var target = element.querySelector('.combinationTarget');
          var selectorTagName = selector[0] ? selector[0].tagName.toLowerCase() : undefined;
          var inputType = selector[0].getAttribute('type') ? selector[0].getAttribute('type').toLowerCase() : undefined;
          var propertySwitching = function propertySwitching() {
            switch (selectorTagName) {
              case 'select':
                if (trigger.selected) {
                  target.disabled = false;
                } else {
                  target.disabled = true;
                  // target.value = null;
                }

                break;
              case 'input':
                if (inputType === 'radio' || inputType === 'checkbox') {
                  if (trigger.checked) {
                    target.disabled = false;
                  } else {
                    target.disabled = true;
                    // target.value = null;
                  }
                }

                break;
            }
          };
          propertySwitching();
          selector.forEach(function (element) {
            element.addEventListener('change', propertySwitching);
          });
        });
      } catch (error) {
        console.log(error);
      }
    }
  }]);
  return combinationSlectText;
}();
exports["default"] = combinationSlectText;

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var easing = /*#__PURE__*/function () {
  function easing() {
    _classCallCheck(this, easing);
  }
  _createClass(easing, null, [{
    key: "quad",
    value: function quad(x, method) {
      switch (method) {
        case 'in':
          return x * x;
        case 'out':
          return 1 - (1 - x) * (1 - x);
        case 'inout':
          return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
      }
    }
  }]);
  return easing;
}();
exports["default"] = easing;

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * リンクテキストをインプット要素の値として設定
 * @module inputValueChange
 */
var inputValueChange = /*#__PURE__*/function () {
  function inputValueChange() {
    _classCallCheck(this, inputValueChange);
  }
  _createClass(inputValueChange, null, [{
    key: "init",
    value: function init(selector) {
      try {
        var triggers = document.querySelectorAll(selector);
        var errorMessage = 'There is no element to apply the "inputValueChange"';
        if (triggers.length < 1) throw errorMessage;
        triggers.forEach(function (element) {
          var target = document.getElementById(element.getAttribute('data-changeTarget'));
          var string = element.textContent;
          element.addEventListener('click', function (e) {
            target.value = string;
          });
        });
      } catch (error) {
        console.log(error);
      }
    }
  }]);
  return inputValueChange;
}();
exports["default"] = inputValueChange;

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * リンク noopener 付与
 * @module noOpener
 */
var noOpener = /*#__PURE__*/function () {
  function noOpener() {
    _classCallCheck(this, noOpener);
  }
  _createClass(noOpener, null, [{
    key: "init",
    value: function init() {
      try {
        var anchor = document.querySelectorAll("a[target*=\"_blank\"]");
        if (anchor.length < 1) throw 'There is no external anchor element to apply the "noopener"';
        anchor.forEach(function (element) {
          element.setAttribute('rel', 'noopener');
        });
      } catch (error) {
        console.log(error);
      }
    }
  }]);
  return noOpener;
}();
exports["default"] = noOpener;

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * 半角英数のみ入力強制
 * @module numericValidator
 * @constructor
 * @param {HTMLElement} selector - 適用対象
 */
var numericValidator = /*#__PURE__*/function () {
  function numericValidator(selector) {
    _classCallCheck(this, numericValidator);
    this.selector = selector;
  }
  _createClass(numericValidator, [{
    key: "filter",
    value: function filter(e) {
      var v = e.target.value.replace(/[０-９]/g, function (x) {
        return String.fromCharCode(x.charCodeAt(0) - 0xFEE0);
      }).replace(/[^0-9]/g, '');
      e.target.value = v;
    }
  }, {
    key: "init",
    value: function init() {
      var _this = this;
      try {
        var target = document.querySelectorAll(this.selector);
        if (target.length < 1) throw "There is no element (".concat(this.selector, ") to apply the \"numericValidator\"");
        target.forEach(function (element) {
          var isComposing = false;
          element.addEventListener('input', function (e) {
            if (!isComposing) _this.filter(e);
          });
          element.addEventListener('compositionstart', function () {
            isComposing = true;
          });
          element.addEventListener('compositionend', function (e) {
            isComposing = false;
            setTimeout(function () {
              _this.filter(e);
            }, 0);
          });
        });
      } catch (error) {
        console.log(error);
      }
    }
  }]);
  return numericValidator;
}();
exports["default"] = numericValidator;

},{}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * 画像先行読み込み
 * @module preloadImage
 * @constructor
 * @param {Array} items - 対象のファイルパス（配列）
 */
var preloadImage = /*#__PURE__*/function () {
  function preloadImage(items) {
    _classCallCheck(this, preloadImage);
    this.items = items ? items : undefined;
  }
  _createClass(preloadImage, [{
    key: "init",
    value: function init() {
      var _this = this;
      try {
        if (!this.items) throw 'There is no item.';
        window.onload = function () {
          _this.items.forEach(function (v) {
            return new Image().src = v;
          });
        };
      } catch (error) {
        console.log(error);
      }
    }
  }]);
  return preloadImage;
}();
exports["default"] = preloadImage;

},{}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * セレクトボックスクラス切り替え
 * @module selectBoxClassToggle
 */
var selectBoxClassToggle = /*#__PURE__*/function () {
  function selectBoxClassToggle() {
    _classCallCheck(this, selectBoxClassToggle);
  }
  _createClass(selectBoxClassToggle, null, [{
    key: "init",
    value: function init() {
      try {
        var selectBox = document.querySelectorAll('.form-select > .select');
        if (selectBox.length < 1) throw 'There is no element to apply the "selectBoxClassToggle"';
        selectBox.forEach(function (element) {
          if (element.disabled) {
            element.parentNode.classList.add('-disabled');
          } else {
            if (element.selectedIndex === 0) {
              element.parentNode.classList.add('-default');
            }
            element.addEventListener('change', function (event) {
              if (element.selectedIndex === 0) {
                element.parentNode.classList.add('-default');
              } else {
                element.parentNode.classList.remove('-default');
              }
            });
          }
        });
      } catch (error) {
        console.log(error);
      }
    }
  }]);
  return selectBoxClassToggle;
}();
exports["default"] = selectBoxClassToggle;

},{}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * スムーススクロール
 * @module smoothScroll
 * @constructor
 * @param {string} exclusion - 除外対象のセレクタ（文字列。複数の場合はカンマ区切り）
 */
var smoothScroll = /*#__PURE__*/function () {
  function smoothScroll(exclusion) {
    _classCallCheck(this, smoothScroll);
    this.exclusion = exclusion ? exclusion : undefined;
  }
  _createClass(smoothScroll, [{
    key: "init",
    value: function init() {
      try {
        var exclusion_string = '';
        if (this.exclusion) {
          if (this.exclusion.match(',')) {
            var exclusionList = this.exclusion.replace('', ' ').split(',');
            exclusionList.forEach(function (element) {
              exclusion_string += ":not(".concat(element, ")");
            });
          } else {
            exclusion_string = this.exclusion;
          }
        }
        var anchor = document.querySelectorAll("a[href*=\"#\"]".concat(exclusion_string));
        if (anchor.length < 1) throw 'There is no element to apply the "smooth scroll"';
        anchor.forEach(function (element) {
          var linkTarget = element.hash.slice(1).length > 0 ? document.getElementById(element.hash.slice(1)) : undefined;
          var focusable = false;
          if (linkTarget) {
            var linkTarget_tag = linkTarget.tagName.toLowerCase();
            if (linkTarget_tag === 'input' || linkTarget_tag === 'select' || linkTarget_tag === 'textarea' || linkTarget_tag === 'button' || linkTarget_tag === 'object' || linkTarget_tag === 'a') focusable = true;
            linkTarget.classList.add('_isInpageLinkTarget');
            element.addEventListener('click', function (event) {
              var linkTarget_top = linkTarget.getBoundingClientRect().top;
              var y_current = window.pageYOffset;
              var y_target = Math.round(linkTarget_top + y_current);
              var onScroll = function onScroll() {
                var scrollTop = window.scrollTop || window.pageYOffset;
                if (scrollTop === y_target) {
                  if (focusable === false) linkTarget.tabIndex = -1;
                  linkTarget.focus();
                  if (focusable === false) linkTarget.removeAttribute('tabIndex');
                  window.removeEventListener('scroll', onScroll);
                }
              };
              window.addEventListener('scroll', onScroll);
              onScroll();
              window.scrollTo({
                top: y_target,
                behavior: 'smooth'
              });
              event.preventDefault();
            });
          }
        });
      } catch (error) {
        console.log(error);
      }
    }
  }]);
  return smoothScroll;
}();
exports["default"] = smoothScroll;

},{}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * 対象項目入力による決定ボタンの活性化
 * @module submitStateChange
 */
var submitStateChange = /*#__PURE__*/function () {
  function submitStateChange() {
    _classCallCheck(this, submitStateChange);
  }
  _createClass(submitStateChange, null, [{
    key: "init",
    value: function init(selector) {
      try {
        var targetForm = document.querySelectorAll(selector);
        var errorMessage = 'There is no element to apply the "submitStateChange"';
        if (targetForm.length < 1) throw errorMessage;
        targetForm.forEach(function (element) {
          var submit = element.querySelector('.submitStateChangeButton');
          var triggers = element.querySelectorAll('*:required');
          var stateChange = function stateChange() {
            var isRequired = element.checkValidity();
            if (isRequired) {
              submit.disabled = false;
            } else {
              submit.disabled = true;
            }
          };
          stateChange();
          triggers.forEach(function (element) {
            element.addEventListener('change', stateChange);
            element.addEventListener('input', stateChange);
          });
        });
      } catch (error) {
        console.log(error);
      }
    }
  }]);
  return submitStateChange;
}();
exports["default"] = submitStateChange;

},{}]},{},[1]);
